import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/document-upload.png'
import _imports_1 from '@/assets/img/video-upload.png'
import _imports_2 from '@/assets/img/tips.png'
import _imports_3 from '@/assets/img/toTop.png'


const _withScopeId = n => (_pushScopeId("data-v-8c6d804c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = {
  key: 0,
  class: "courseDetail"
}
const _hoisted_3 = {
  key: 1,
  class: "topicDetail"
}
const _hoisted_4 = { class: "common-wrap" }
const _hoisted_5 = { class: "upload-select" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "上传文档文件", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "上传视频微课", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "资源上传须知")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-item" }, " 2. 支持格式：doc(docx)、xls(xlsx)、ppt(pptx)、pdf、txt、flv、mp4、mp3、jpg(gif、png、bmp)等 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-item" }, " 3. 资源大小不得超过1GB（文档资源上传上限为50M；视频资源上传上限为1G） ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statement-content" }, " 本人通过本网站提交的作品（含文字及其他形式）具有自主知识产权， 并遵守《全国人大常委会关于维护互联网安全的决定》 及中华人民共和国其他各项有关法律法规的规定。 如该作品在本网站刊载后引起著作权纠纷或其他法律纠纷，将由本人承担相应的民事或刑事法律责任。 同时，本单位享有对相关资源进行宣传、使用和推介的权利。 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "学时", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "说明", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my_header" }, "学时说明", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "study-tips" }, [
  /*#__PURE__*/_createTextVNode(" • 用户报名学习精品课堂中带有"),
  /*#__PURE__*/_createElementVNode("span", { class: "colorRed" }, "【学时】"),
  /*#__PURE__*/_createTextVNode("标签的课程，完成学习后可获得培训学时，每累计学习30分钟=1学时； ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "study-tips" }, " • 同一门课程反复观看只计入一次学习时间，如课程时长为60分钟，学习时间最多只计60分钟，超出部分不累计；单门课程观看不足1分钟的不计时； ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "study-tips mb32" }, " • 所有课程累计的学习时间越多，所得学时数就越多，获得的成长等级权益就越高，且已获得的学时可申请电子学时证明； ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "study-tips colorRed" }, " • 申请学时证明前，请您咨询当地教师培训部门，确认本培训学时是否可以计入教师继续教育学分； ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "study-tips" }, " • 申请电子证明时，最少可申请1学时，最多可申请学时不得超过已获得学时数； ", -1))
const _hoisted_27 = { class: "dialog_footer" }

import { onBeforeMount, onBeforeUnmount, onMounted, ref, onUnmounted } from 'vue'
import Header from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import Login from '@/components/login/login.vue'
import BreadCrumb from '@/components/bread-crumb/bread-crumb.vue'
import Dialog from '@/components/dialog/dialog.vue'
import { useRoute, useRouter } from 'vue-router'
import useHomeStore from './store/modules/home'
import { storeToRefs } from 'pinia'
import { getSubjectOption, getTopicInfo } from '@/api'
import throttle from 'lodash/throttle'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import useAccountStore from '@/store/modules/account'
import useMessageStore  from '@/store/modules/message';
import location from '@/utils/location';


import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'App',
  setup(__props) {

const accountStore  = useAccountStore()
const messageStore = useMessageStore()
accountStore.amountStatisticsM()
accountStore.accountInfoM()
messageStore.unreadMessageCountM()

const showTips = ref(false)

const locale = zhCn

const homeStore = useHomeStore()
const { showUpload, defaultTab, showLogin, allStage, subjectList , showSubjectSelect, academicStage, subject, stageAndsubject, } = storeToRefs(homeStore)
const route = useRoute()
const router = useRouter()

const backgroundUrl = ref('');
const getTopicInfoM = () => {
  getTopicInfo({id: route.query.id}).then(res => {
    if (res.success) {
      backgroundUrl.value = res.data.backgroundUrl;
    } else {
      ElMessage.error(res.msg);
    };
  });
};
setTimeout(() => {
  if (route.path == '/pcourse/topicDetail') {
    getTopicInfoM();
  }
}, 500)

//点击上传文档
const clickUploadDoc = () => {
  showUpload.value = false
  defaultTab.value = -1
  router.push({
    path: '/home/uploadDoc'
  })
}
//点击上传视频
const clickUploadVideo = () => {
  showUpload.value = false
  router.push({
    path: '/home/uploadVideo'
  })
}
// 获取学段
const getSubjectOptionM = async () => {
  const res = await getSubjectOption({ dictId: 0, dictLevel: 1 })
  if (res.code == 0) {
    allStage.value = res.data
    allStage.value.unshift({
      dictName: '全部',
      id: null
    })

  }
}
getSubjectOptionM()

// 第一次进入显示学科学段弹窗
const firstEnterHandle = ()=>{
   // 检查存储中是否有访问标志
   const hasVisited = sessionStorage.getItem('hasVisited');
    console.log('hasVisited', hasVisited)
    if (!hasVisited) {
      // 如果没有访问标志，显示弹窗并将访问标志保存到本地存储
      console.log('showSubjectSelect')
      academicStage.value = {
        dictName: '全部',
        id: null
      }
      subjectList.value = [{
          dictName: '全部学科',
          id: null
        }]
      subject.value = {}
      stageAndsubject.value = '全部学科'
      defaultTab.value = 0
      showSubjectSelect.value = true
      sessionStorage.setItem('hasVisited', 'true');
    }
}
firstEnterHandle()

//点击原创说明
const showTipsDialog = ref(false)
const clickTips = () => {
  showTipsDialog.value = true
}

//点击我同意
const clickIAgree = () => {
  showTipsDialog.value = false
}

//监听window滚动
const showToTop = ref(false)
const scrollListener = throttle(() => {
  const scrollTop = document.documentElement.scrollTop
  // const clientHeight = document.documentElement.clientHeight
  // const scrollHeight = document.documentElement.scrollHeight
  // if (scrollTop + clientHeight >= scrollHeight) {
  //   // 已无更多数据
  //   if (totalCount.value <= homepageList.value.length) {
  //     return
  //   }
  //   clickMore()
  // }
  showToTop.value = scrollTop > 176

}, 100)

//点击去顶部
const clickToTop = () => {
  window.scroll({
    top: 0,
    behavior: "smooth",
  })
}

onMounted(() => {
  window.addEventListener('scroll', scrollListener)
  // homeStore.$reset()
})

onUnmounted(() => {
  window.removeEventListener('scroll', scrollListener)
})


// 解决ERROR ResizeObserver loop completed with undelivered notifications.
//问题的
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}
// 解决ERROR ResizeObserver loop completed with undelivered notifications.
//问题的
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

const toPreview = () => {
  window.open(location.files() + 'user/courseZS/model/course_pc_common.jpg')
}



return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_config_provider = _resolveComponent("el-config-provider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_config_provider, { locale: _unref(locale) }, {
      default: _withCtx(() => [
        (_unref(route).path != '/coursePreview')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createVNode(Header, null, null, 512), [
                [_vShow, _unref(route).meta.showHeader]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["center", [
          _unref(route).path.includes('personSpace') ? 'bgImage':'',
          _unref(route).path.includes('pcourse') ? 'pcourse':'']])
              }, [
                (_unref(route).path == '/pcourse/courseDetail')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                  : _createCommentVNode("", true),
                (_unref(route).path == '/pcourse/topicDetail')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createVNode(BreadCrumb, null, null, 512), [
                    [_vShow, !_unref(route).meta.hiddenBread]
                  ]),
                  _createVNode(_component_router_view)
                ])
              ], 2),
              _createVNode(Footer)
            ], 64))
          : _createCommentVNode("", true),
        (_unref(route).path == '/coursePreview')
          ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(Dialog, {
          modelValue: _unref(showUpload),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(showUpload) ? (showUpload).value = $event : null)),
          title: "上传资源"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", { class: "toUpload" }, [
                _createElementVNode("div", {
                  class: "document item",
                  onClick: clickUploadDoc
                }, _hoisted_8),
                _createElementVNode("div", {
                  class: "video item",
                  onClick: clickUploadVideo
                }, _hoisted_11)
              ]),
              _createElementVNode("div", { class: "tips" }, [
                _hoisted_12,
                _createElementVNode("div", { class: "tips-item" }, [
                  _createTextVNode(" 1. 请勿在未经授权的情况下上传任何涉及版权侵权的资源内容！在本站上传资源，默认代表同意 "),
                  _createElementVNode("span", {
                    class: "colorHover curPointer",
                    onClick: clickTips
                  }, "《作品原创声明》")
                ]),
                _hoisted_13,
                _hoisted_14
              ]),
              _createVNode(Dialog, {
                modelValue: showTipsDialog.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((showTipsDialog).value = $event)),
                class: "clearRadiusColor",
                title: "作品原创声明"
              }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _createElementVNode("div", { class: "statement-bottom" }, [
                    _createElementVNode("div", {
                      class: "st-btn",
                      onClick: clickIAgree
                    }, "确定")
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_unref(showLogin))
          ? (_openBlock(), _createBlock(Login, { key: 2 }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "toTop",
          onClick: clickToTop
        }, _hoisted_17, 512), [
          [_vShow, showToTop.value]
        ]),
        (_unref(route).path == '/pcourse/index' || _unref(route).path == '/pcourse/topic' || _unref(route).path == '/pcourse/allcourse' )
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "fixed",
              onClick: _cache[2] || (_cache[2] = $event => (showTips.value = true))
            }, _hoisted_20))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dialog, {
          class: "dialog",
          style: {"border-radius":"16px","padding":"4px 10px"},
          modelValue: showTips.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((showTips).value = $event)),
          width: "1000"
        }, {
          header: _withCtx(() => [
            _hoisted_21
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", {
                class: "sure",
                onClick: _cache[3] || (_cache[3] = $event => (showTips.value = false))
              }, "确定")
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _hoisted_25,
            _createElementVNode("div", {
              class: "study-tips colorBlue mb32",
              onClick: toPreview
            }, " 学时证明样本预览 > "),
            _hoisted_26
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}
}

}